import { takeLatest, call, put, select } from "redux-saga/effects";
import {
  GET_AZURE_METRICS_RESPONSE,
  GET_AZURE_METRICS_RESPONSE_SUCCESS,
  GET_AZURE_METRICS_RESPONSE_ERROR,
} from "./constant";

import { getAzureMetricsResponseApi } from "./api";

/**
 * action Type of GET_DASHBOARD_INFO
 * @param {Object} action
 */
function* getAzureMetricsResponseList(params) {
  try {
    const provider = yield select(state => state.CloudProviderStore ? state.CloudProviderStore.selectedProvider : "azure");
    const data = yield call(getAzureMetricsResponseApi, params, provider);
    yield put({ type: GET_AZURE_METRICS_RESPONSE_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_AZURE_METRICS_RESPONSE_ERROR, error });
  }
}

/**
 * Get Login Saga
 */
export function* manageAzureMetricsResponseSaga() {
  yield takeLatest(GET_AZURE_METRICS_RESPONSE, getAzureMetricsResponseList);
}
